import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const HeaderSection = () => {
    const [count, setCount] = useState(null);

    useEffect(() => {
        fetch('https://api.admin.marsreel.com/api/preferences/count')
            .then(res => res.json())
            .then(data => {
                if (data.count !== undefined) {
                    setCount(data.count);
                }
            })
            .catch(err => {
                console.error('Failed to fetch preference count:', err);
                setCount(0); // fallback
            });
    }, []);

    return (
        <>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
                Preferences Overview
            </Typography>
            <Typography variant="body2" sx={{ color: '#aaa', mb: 2 }}>
                Preferences aggregated from{' '}
                {count !== null ? count.toLocaleString() : '...'} submitted preferences
            </Typography>
        </>
    );
};

export default HeaderSection;
